import { Anchor, Breadcrumbs as MantineBreadcrumbs, Text, useMantineTheme } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';

export function Breadcrumbs({ items }) {
  const theme = useMantineTheme();
  const breadcrumbLinks = items.map((item, index) => {
    if (item.active || !item.path) {
      return (
        <Text key={index} fw={500} c={theme.colors.dark[8]}>
          {item.name}
        </Text>
      );
    }

    return (
      <Anchor component={Link} to={item.path} key={index}>
        {item.name}
      </Anchor>
    );
  });

  return (
    <MantineBreadcrumbs mb="md" separator={<ChevronRight size={12} />}>
      {breadcrumbLinks}
    </MantineBreadcrumbs>
  );
}
